import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24.96 33.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.96 33.7\" id=\"icon-search\"><path d=\"M23.08,19.1a12.51,12.51,0,0,0-4-17.2,12.45,12.45,0,0,0-17.2,4,12.51,12.51,0,0,0,4,17.2,12.29,12.29,0,0,0,6.6,1.9,8.63,8.63,0,0,0,2.8-.4L19,33.7h4.4l-4.3-10.6A11.78,11.78,0,0,0,23.08,19.1Zm-15.2.8A8.75,8.75,0,0,1,4,14.4a8.12,8.12,0,0,1,1.1-6.6,8.63,8.63,0,0,1,7.4-4.1A9.4,9.4,0,0,1,17.08,5,8.75,8.75,0,0,1,21,10.5a8.12,8.12,0,0,1-1.1,6.6,8.63,8.63,0,0,1-7.4,4.1A7.68,7.68,0,0,1,7.88,19.9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/search.svg
// module id = 309
// module chunks = 0 1